import { Link } from 'react-router-dom';
import HubLayout from '../../../components/hub/HubLayout.jsx';
import config from '../../../data/hubs/comptia-secplus/config.js';

export default function Overview() {
  const base = `/hub/${config.slug}`;
  return (
    <HubLayout config={config}>
      <section className="hero">
        <div className="hero-content">
          <div className="hero-eyebrow">Mission Briefing · 90-Day Track</div>
          <h1 className="hero-title">Pass the exam.<span className="accent"> Operate the field.</span></h1>
          <p className="hero-lede">
            A no-fluff study environment for CompTIA Security+ (SY0-701). Five domains decomposed into
            objectives, a twelve-week tempo, vetted resources, and a one-page cheat sheet for the final
            week. Built to read like a console, not a course.
          </p>
          <div className="hero-cta">
            <Link to={`${base}/domains`} className="btn">Begin Domain Recon</Link>
            <Link to={`${base}/study-plan`} className="btn btn-ghost">Load 12-Week Plan</Link>
          </div>
        </div>
      </section>

      <section>
        <div className="section-head">
          <h2><span className="num">01</span>Quick Navigation</h2>
          <span className="section-tag">Modules · 06</span>
        </div>
        <div className="qlink-grid">
          <Link to={`${base}/domains`} className="qlink">
            <div className="qlink-id">MOD&nbsp;001</div>
            <h4>Exam Domains</h4>
            <span className="desc">Five-domain breakdown with objectives and weights.</span>
            <span className="arrow">→</span>
          </Link>
          <Link to={`${base}/study-plan`} className="qlink">
            <div className="qlink-id">MOD&nbsp;002</div>
            <h4>12-Week Plan</h4>
            <span className="desc">Daily/weekly tempo from objective scan to mock exam.</span>
            <span className="arrow">→</span>
          </Link>
          <Link to={`${base}/flashcards`} className="qlink">
            <div className="qlink-id">MOD&nbsp;003</div>
            <h4>Flashcards</h4>
            <span className="desc">150+ cards across all five domains. Track got-it / review.</span>
            <span className="arrow">→</span>
          </Link>
          <Link to={`${base}/practice-test`} className="qlink">
            <div className="qlink-id">MOD&nbsp;004</div>
            <h4>Practice Test</h4>
            <span className="desc">90 questions, 90 minutes, weighted to SY0-701 distribution.</span>
            <span className="arrow">→</span>
          </Link>
          <Link to={`${base}/objective-tests`} className="qlink">
            <div className="qlink-id">MOD&nbsp;005</div>
            <h4>Objective Tests</h4>
            <span className="desc">Per-domain 30-question drills, 30-minute timer each.</span>
            <span className="arrow">→</span>
          </Link>
          <Link to={`${base}/cheat-sheet`} className="qlink">
            <div className="qlink-id">MOD&nbsp;006</div>
            <h4>Cheat Sheet</h4>
            <span className="desc">One-page printable reference for week-12 review.</span>
            <span className="arrow">→</span>
          </Link>
        </div>
      </section>

      <section>
        <div className="section-head">
          <h2><span className="num">02</span>Inside the Console</h2>
          <span className="section-tag">Loadout</span>
        </div>
        <ul className="feature-list">
          <li><strong>DOMAIN DETAILS</strong>Concise objective summaries for all five SY0-701 domains, with exam weighting and the specific terms most likely to appear on test day.</li>
          <li><strong>STUDY MATERIALS</strong>Curated books, video courses, free hands-on labs, and the practice-exam vendors that actually mirror exam difficulty.</li>
          <li><strong>STUDY SCHEDULE</strong>A twelve-week cadence built around 10–12 hours per week, with milestones you can check off and a final-week sprint protocol.</li>
          <li><strong>CHEAT SHEET</strong>Printable single-page reference: top attacks, encryption, IR steps, port table, compliance, and design principles.</li>
          <li><strong>TEST-TAKING TACTICS</strong>Performance-based question strategy, time budgeting, the "two-pass" approach, and how to handle drag-and-drop simulation items.</li>
        </ul>
      </section>

      <section>
        <div className="section-head">
          <h2><span className="num">03</span>Exam Snapshot</h2>
          <span className="section-tag">Intel · SY0-701</span>
        </div>
        <div className="grid grid-4">
          <div className="card"><div className="card-num"><span>QUESTIONS</span><span className="weight">MAX 90</span></div><h3>Performance-based + multiple choice</h3><p>Mixed format. Skip PBQs first if time-pressed; come back when MCQs are locked in.</p></div>
          <div className="card"><div className="card-num"><span>DURATION</span><span className="weight">90 MIN</span></div><h3>Tight time budget</h3><p>Roughly one minute per question. PBQs eat 4–6 minutes each. Pace accordingly.</p></div>
          <div className="card"><div className="card-num"><span>PASSING</span><span className="weight">750/900</span></div><h3>Scaled score</h3><p>Roughly 83 percent. No partial credit on PBQs — get every drag-and-drop step right.</p></div>
          <div className="card"><div className="card-num"><span>VALIDITY</span><span className="weight">3 YRS</span></div><h3>CEU renewal eligible</h3><p>Renew via continuing-education units or by passing a higher CompTIA cert.</p></div>
        </div>
        <div className="callout">
          <strong>Operator Note</strong>
          Every external link in the Resources module opens in a new tab so this console stays open as your command surface during study.
        </div>
      </section>
    </HubLayout>
  );
}
